import React from 'react';
import Typography from "@material-ui/core/Typography";
import { isLocalRequest } from '../../../api/api-client';
import { connect } from 'react-redux';

function ProfileLabel({ classStyle, user}) {

    const userRole = {
        support: "Suporte",
        farmer: "Fazendeiro",
        warehouse: "Armazém",
        transporter: "Transportadora",
        driver: "Motorista",
        backoffice: "BackOffice",
    };

    return (
        <>
            <Typography className={classStyle} variant="subtitle2">
                {userRole[user.mainGroup]}
            </Typography>
        
            
            {(user && isLocalRequest) && (
                <button onClick={() => {
                    const tokenData = window.localStorage.getItem('userData') || '';
                    if (tokenData) {
                        window.open(`http://localhost:3001/spa-signin/${JSON.parse(tokenData).user.token}`) 
                    }
                }}>
                    Peach Access
                </button>
                )
            }
        </>
    );

}

const mapState = ({ auth: { user } }) => ({ user });

export default connect(mapState, null)(ProfileLabel);